import React, { Component } from 'react';
import styled from 'styled-components';
import firebase from 'firebase';

import { fromUnixTime, formatDistance } from 'date-fns';

const AllMsgContainer = styled.div`
	background-color: #ffffff;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	height: 120px;
	margin-bottom: 20px;
	padding: 20px;
	position: relative;
	cursor: pointer;
	&:hover {
		background-color: #e4e4e4;
	}
`;

const AllMsgEmailTimeContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
`;

const AllMsgUserEmail = styled.h4`
	color: #46494c;
	margin: 0;
	text-decoration: none;
`;

const AllMsgUserTimeAgo = styled.h4`
	color: #6d7278;
	margin: 0;
`;

const AllMsgUserText = styled.p`
	color: #6d7278;
	font-weight: 300;
`;

const AllMsgStatus = styled.div`
	align-items: center;
	background-color: ${(props) => (props.closed ? '#272D2D' : '#03a9f4')};
	border-radius: 10px 0 0 0;
	bottom: 0;
	color: #ffffff;
	display: flex;
	font-size: 12px;
	font-weight: 500;
	height: 27px;
	justify-content: center;
	position: absolute;
	right: 0;
	width: 60px;
`;

const UserCard = ({ userId, userEmail, lastMsg, created, statusClosed, handleClickOnTicket, handleConvertDate }) => {
	return (
		// <AllMsgContainer onClick={() => handleClickOnTicket(userId)}>
		<AllMsgContainer>
			<AllMsgEmailTimeContainer>
				<AllMsgUserEmail>{userEmail}</AllMsgUserEmail>
				<AllMsgUserTimeAgo>{handleConvertDate(fromUnixTime(created.seconds))}</AllMsgUserTimeAgo>
			</AllMsgEmailTimeContainer>
			<AllMsgUserText>{lastMsg}</AllMsgUserText>
			<AllMsgStatus closed={statusClosed}>{statusClosed ? 'Closed' : 'New'}</AllMsgStatus>
		</AllMsgContainer>
	);
};

export default UserCard;
